import { useEffect, useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { imageUrl } from "@/lib/api";

const TYPES = ["image/jpeg", "image/png", "image/webp"];
const MAX = 5 * 1024 * 1024;

export const PhotoPicker = ({ currentPath, file, removed, onFile, onRemove }) => {
  const input = useRef(null);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (!file) return setPreview("");
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const pick = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!TYPES.includes(f.type)) return toast.error("Format foto harus JPG, PNG, atau WEBP");
    if (f.size > MAX) return toast.error("Ukuran foto maksimal 5 MB");
    onFile(f);
  };

  const src = preview || (!removed && imageUrl(currentPath));

  return (
    <div className="flex items-center gap-4" data-testid="product-photo-picker">
      <button type="button" onClick={() => input.current?.click()} data-testid="product-photo-select-button"
        className="relative flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 text-slate-400 transition-colors hover:border-emerald-400 hover:text-emerald-600">
        {src ? <img src={src} alt="Foto produk" className="h-full w-full object-cover" data-testid="product-photo-preview" /> : <ImagePlus className="h-7 w-7" />}
      </button>
      <div className="space-y-1 text-sm">
        <p className="font-medium text-slate-700">Foto Produk</p>
        <p className="text-xs text-slate-500">JPG, PNG, atau WEBP, maks. 5 MB</p>
        <div className="flex gap-3 pt-1">
          <button type="button" onClick={() => input.current?.click()} className="text-xs font-semibold text-emerald-700 hover:underline" data-testid="product-photo-change-button">
            {src ? "Ganti foto" : "Pilih foto"}
          </button>
          {src && (
            <button type="button" onClick={onRemove} className="flex items-center gap-0.5 text-xs font-semibold text-red-600 hover:underline" data-testid="product-photo-remove-button">
              <X className="h-3 w-3" /> Hapus
            </button>
          )}
        </div>
      </div>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid="product-photo-file-input" />
    </div>
  );
};
